import { Box, Typography } from '@mui/material';
import { ArcElement, Chart, Tooltip } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { sumWithCurrency } from 'core/services/currency.service';
import { on } from 'events';
import { ChartProps, Doughnut } from 'react-chartjs-2';
Chart.register(Tooltip);
Chart.register(ArcElement);
Chart.register(ChartDataLabels);

export interface PieChartProps extends Omit<ChartProps<'doughnut'>, 'type'> {
  onItemClick?: (item: any) => void;
  tooltipFormatter?: (item: any) => string;
}

const PieChart = ({ data, onItemClick, tooltipFormatter }: PieChartProps) => {
  return (
    <div>
      <Doughnut
        data={data}
        options={
          {
            onClick: (e: any, item: any) => {
              const index = item[0]?.index;
              index != undefined && onItemClick?.(index);
            },
            layout: {
              padding: 15
            },
            cutout: '30%',
            elements: {
              arc: {
                borderWidth: 1,
                borderColor: '#ccc'
              }
            },
            plugins: {
              tooltip: {
                callbacks: {
                  label: tooltipFormatter
                }
              },
              onClick: () => {}
            }
          } as any
        }
      />
    </div>
  );
};

export default PieChart;
